module.exports = __webpack_public_path__ + "static/media/icon_anchor.3fa9dcdd.svg";